import { useQuery, UseQueryOptions } from 'react-query';
import { ErrorResponse } from '../../../../../types/API';
import { wgApi } from '../../../../app/src/features/api/wgApi';
import {
  CalculateYellowhiveQuotesBySessionIdBody,
  CalculateYellowhiveQuotesBySessionIdResponse,
  SchemaYellowHiveQuote,
} from 'wg-api-sdk';
import { JobResult } from '@flows/src/types/Jobs';

interface Params {
  sessionId?: string;
  queryOptions?: UseQueryOptions<CalculateYellowhiveQuotesBySessionIdResponse>;
}

// Main API call - Returns quotes with job information
export const getYellowhiveQuotes = async (
  sessionId: string,
  payload?: CalculateYellowhiveQuotesBySessionIdBody,
) => {
  const { data, isError } =
    await wgApi.post<CalculateYellowhiveQuotesBySessionIdResponse>(
      `/v1/api/yellowhiveflows/conversations/${sessionId}/calculate`,
      payload,
    );
  if (isError) throw new Error(JSON.stringify(data as ErrorResponse));
  return data;
};

export const getUseYellowhiveQuotesQKey = (sessionId: string) => [
  'flow-products',
  'yellowhive',
  'quotes',
  sessionId,
];

export const getJobResultQKey = (jobId: string) => [
  'flow-products',
  'yellowhive',
  'job-result',
  jobId,
];

export const useYellowhiveQuotes = ({ sessionId, queryOptions }: Params) => {
  return useQuery<CalculateYellowhiveQuotesBySessionIdResponse>(
    getUseYellowhiveQuotesQKey(sessionId!),
    () => getYellowhiveQuotes(sessionId!),
    {
      refetchOnMount: false,
      retry: false,
      refetchOnWindowFocus: false,
      enabled: !!sessionId,
      ...queryOptions,
    },
  );
};

export const getYellowHiveQuotesJobResult = async (jobId: string) => {
  const { data, isError } = await wgApi.get<JobResult<SchemaYellowHiveQuote>>(
    `/v1/api/flows/jobs/${jobId}`,
  );
  if (isError) throw new Error(JSON.stringify(data as ErrorResponse));
  return data;
};
